const macUaRegex = /(Mac OS X|Mac OS|MacPPC|MacIntel|Mac_PowerPC|Macintosh)/;

export function isMacOs() {
  return typeof navigator === "object" && macUaRegex.test(navigator.userAgent);
}
